import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNotification } from '../contexts/NotificationContext';
import { useSystemParameters } from '../contexts/SystemParametersContext';

export const NotificationDataSync: React.FC = () => {
    const { isAuthenticated } = useAuth();
    const { fetchUserNotifications } = useNotification();
    const { getParam } = useSystemParameters();

    useEffect(() => {
        if (isAuthenticated) {
            // Always load for first time
            fetchUserNotifications();

            // Read timer parameter in seconds (0 = disabled)
            const timerSecStr = getParam('Sync_Notifications_Timer_Seconds', '0');
            const timerSec = parseInt(timerSecStr, 10);

            if (!isNaN(timerSec) && timerSec > 0) {
                const interval = setInterval(fetchUserNotifications, timerSec * 1000);
                return () => clearInterval(interval);
            }
        }
    }, [isAuthenticated, fetchUserNotifications, getParam]);

    return null;
};
